import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="transparent"
      d="M6.627 7.227 8.87 3.335a2.167 2.167 0 0 1 4.024 1.382l-.145 1.033h1.377c.688 0 1.583.32 2.305.899.746.596 1.383 1.53 1.383 2.788 0 1.153-.552 2.89-1.338 4.315-.4.724-.885 1.416-1.437 1.938-.544.512-1.234.934-2.027.934-2.77 0-5.143-.64-6.334-.979h-.05a2.297 2.297 0 0 1-4.378-.972v-6.47a2.297 2.297 0 0 1 4.377-.976"
    />
    <path
      fillRule="evenodd"
      d="M10.748 3.75a.67.67 0 0 0-.578.334L7.433 8.833a.75.75 0 0 1-.589.373v4.942q.075.006.145.026c1.131.323 3.392.95 6.023.95.248 0 .586-.137.997-.526.402-.38.8-.929 1.153-1.57.72-1.304 1.152-2.786 1.152-3.59 0-.701-.342-1.236-.82-1.618-.502-.402-1.075-.57-1.367-.57h-2.24a.75.75 0 0 1-.743-.854l.264-1.887a.667.667 0 0 0-.66-.759M6.627 7.227 8.87 3.335a2.167 2.167 0 0 1 4.024 1.382l-.145 1.033h1.377c.688 0 1.583.32 2.305.899.746.596 1.383 1.53 1.383 2.788 0 1.153-.552 2.89-1.338 4.315-.4.724-.885 1.416-1.437 1.938-.544.512-1.234.934-2.027.934-2.77 0-5.143-.64-6.334-.979h-.05a2.297 2.297 0 0 1-4.378-.972v-6.47a2.297 2.297 0 0 1 4.377-.976m-2.08.18a.797.797 0 0 0-.797.796v6.47a.797.797 0 1 0 1.594 0v-6.47a.797.797 0 0 0-.797-.797Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLike;
